import { render, staticRenderFns } from "./UserFollow.vue?vue&type=template&id=daf19c7c&scoped=true&"
import script from "./UserFollow.vue?vue&type=script&lang=js&"
export * from "./UserFollow.vue?vue&type=script&lang=js&"
import style0 from "./UserFollow.vue?vue&type=style&index=0&id=daf19c7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf19c7c",
  null
  
)

export default component.exports